import mandantenUsers from './mandantenUsers';
import meineDokumente from './meineDokumente';
import aenderungsmodus from './aenderungsmodus';

export default {
  mandantenUsers,
  meineDokumente,
  aenderungsmodus,
};
